import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { HopeContext } from '../Context/HopeWidgetContext';
import { SET_BATCH_MODE, SET_SELECTED_ROWS } from '../Context/constants';
import { StyledBatchButton } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const CancelButton = () => {
  const {
    palette: { primary },
  } = useTheme() as any;
  const { dispatch, batchMode, showLoader } = useContext(HopeContext);

  // styles defined here to override MUI css
  return (
    <>
      {batchMode && (
        <StyledBatchButton
          style={{
            color: showLoader ? 'grey' : primary.contrastText,
            backgroundColor: primary.main,
            fontSize: '10px',
            height: '1.25em',
            fontWeight: 'bold',
            padding: '10px',
            margin: '5px',
          }}
          onClick={() => {
            dispatch({ type: SET_BATCH_MODE, payload: null });
            dispatch({
              type: SET_SELECTED_ROWS,
              payload: null,
            });
          }}
          disabled={!!showLoader}
        >
          {`${defaults.cancel}`}
        </StyledBatchButton>
      )}
    </>
  );
};
